import { STANDARD_BRANCH } from '@festina-life/api'

import { OperationApproval } from '../../components/operationApproval/OperationApproval'
import { OperationViewerTopBar } from '../../components/operationViewerTopBar/OperationViewerTopBar'
import { useEnumId } from '../../hooks/useEnumId'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'
import { EnumTransferButton } from './EnumTransferButton'

export const EnumViewerTopBar = () => {
  const enumId = useEnumId()
  const { branch } = useNavigationParams()
  const { applicationEnumDefinitions } = useApplicationViewOperationsContext()
  const configuredEnumForId = applicationEnumDefinitions.get(enumId)

  const isDraftEnum = configuredEnumForId?.isDraft
  const changesetKey = configuredEnumForId?.changesetHistory?.changesetKey
  const operationKey = configuredEnumForId?.internalOperation?.operationKey

  const isRenderingApproval =
    !isDraftEnum && branch !== STANDARD_BRANCH && changesetKey && operationKey

  return (
    <OperationViewerTopBar className="justify-end gap-x-2 mb-3">
      {isRenderingApproval && (
        <OperationApproval
          actions={configuredEnumForId?.actions ?? []}
          changesetKey={changesetKey}
          operationKey={operationKey}
        />
      )}
      <EnumTransferButton />
    </OperationViewerTopBar>
  )
}
